<template>
    <b-card no-body>
        <!-- Add remark modal -->
        <modal :size="'md'" :show.sync=modals.show_create_remark modalClasses="add-remarks">
            <h3 slot="header" class="mb-0 font-weight-500">Add Remark</h3>
            <b-form ref="customerForm" role="form" @submit.prevent="createRemark()" class="mt--4">
                <b-row>
                    <b-col cols="12">
                        <b-form-textarea
                            v-model="new_remark"
                            rows="8"
                            required
                        ></b-form-textarea>
                    </b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2" slot="footer">
                        <b-button type="submit" class="w-100" variant="primary">Submit</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </modal>
        <b-card-header class="py-2">
            <b-row align-v="center">
                <b-col cols="12">
                    <h3 class="mb-0">
                        Remarks
                    </h3>
                </b-col>
            </b-row>
        </b-card-header>
        <div class="px-4 py-3">
            <div v-if="remarks.length > 0">
                <div class="mb-3" v-for="(remark, index) in remarks" :key="index">
                    <p class="mb-0 font-weight-normal text-sm">{{ remark.remark }}</p>
                    <span class="d-flex align-items-center justify-content-between">
                        <small class="text-muted">
                            <span v-if="remark.created_by_detail">by <span class="text-capitalize">{{ remark.created_by_detail.name }}</span> on </span>
                            {{ remark.created_at | dateFormatString }}
                        </small>
                        <a href="javascript:void(0)" @click="removeRemark(remark[`${type}_remark_id`], index)" v-if="remark.created_by === auth_user.id">
                            <i class="fa fa-trash fa-xs text-red"></i>
                        </a>
                    </span>
                </div>
            </div>
           <p class="text-muted font-weight-normal" v-else>No remark found.</p>
           <div class="text-center mt-3">
                <a href="javascript:void(0)" class="text-primary text-sm font-weight-bold" 
                    @click="modals.show_create_remark = true"
                >
                    <i class="fa fa-plus mr-1"></i> Add Remarks
                </a>
           </div>
        </div>
    </b-card>
</template>
<script>
    import { Card, Button } from 'element-ui'
    import {
        notifyFunctionMixin,
        axios,
        getHeader
    } from '@/assets/js/httpImports.js'
    import Modal from "@/components/Modal";
    import { useAuthStore } from '@/stores/authStore'
    import { mapState, mapActions } from 'pinia'

    export default {
        props: ['base_url', 'type'],
        name: 'remark',
        components: {
            [Card.name]: Card,
            [Button.name]: Button,
            Modal
        },
        mixins:[
            notifyFunctionMixin,
        ],
        data(){
            return{
                modals:{
                    show_create_remark:false
                },
                new_remark: '',
                remarks: []
            }
        },
        computed: {
            ...mapState(useAuthStore,['auth_user']),
        },
        created(){
            this.getRemark()
        },
        methods: {
            createRemark(){
                let form = new FormData()
                form.append('remark', this.new_remark)
                axios.post(this.base_url, form, { headers: getHeader() })
                    .then(res => {
                        this.remark = null;
                        this.notifySuccess('<b>Remark : </b> Successfully Created.')
                        this.modals.show_create_remark = false
                        this.new_remark = ''
                        this.remarks.unshift(res.data.data)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            getRemark(){
                axios.get(this.base_url, { headers: getHeader() })
                    .then(res => {
                        this.remarks = res.data.data
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            handleAddRemark(remark){
                this.remarks.push(remark)
            },
            removeRemark(id, index){
                axios.delete(this.base_url+ '/' + id, { headers: getHeader() })
                    .then(res => {
                        this.notifySuccess('<b>Remark : </b> Successfully Deleted.')
                        this.remarks.splice(index, 1)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })      
            }
        }
    }
</script>